/**
 * Gesamtfortschritt eines Ziels (F-12).
 *
 * Ein Ziel kommt auf zwei Wegen voran: seine Key Results messen das Ergebnis,
 * seine Projekte und Aufgaben die Arbeit daran (F-11: "Zielfortschritt aus
 * den zugehoerigen Projekten"). Der Gesamtfortschritt ist das Mittel aus
 * beiden - fehlt einer der Wege, zaehlt nur der andere.
 *
 * Aufgaben zaehlen einzeln (Projekt- und direkt zugeordnete zusammen), damit
 * die Zahl sich als "7 von 12 Aufgaben" nachvollziehen laesst.
 */
import { goalProgress } from '@/domain/goals/progress';
import type { Goal, Task } from '@/domain/types';

export interface GoalOverall {
  /** 0..1 */
  ratio: number;
  /** Anteil der Key Results, fehlt ohne Key Results. */
  keyResults?: number;
  /** Erledigte Aufgaben, fehlt ohne Aufgaben. */
  aufgaben?: { done: number; total: number };
}

/** `tasks`: alle Aufgaben der Projekte des Ziels plus die direkt zugeordneten. */
export function goalOverallProgress(goal: Goal, tasks: Task[]): GoalOverall {
  const ergebnis: GoalOverall = { ratio: 0 };
  const teile: number[] = [];

  if (goal.keyResults.length > 0) {
    ergebnis.keyResults = goalProgress(goal);
    teile.push(ergebnis.keyResults);
  }
  if (tasks.length > 0) {
    const done = tasks.filter((t) => t.status === 'erledigt').length;
    ergebnis.aufgaben = { done, total: tasks.length };
    teile.push(done / tasks.length);
  }
  // Ohne beides ist ein Ziel nicht messbar: 0 %, nicht 100 %.
  if (teile.length > 0) ergebnis.ratio = teile.reduce((a, b) => a + b, 0) / teile.length;
  return ergebnis;
}
